import React from 'react';
import { FormGroup, InputGroup, Input, Row, Col } from 'reactstrap';
import { GreyLabel, UnderlineInput, SmallFormFeedback, StyledInputGroupText, Colors, HighlightedInputGroupText } from '../../../../utils/budget-tool-specific';
import styled from 'styled-components';

const FormInputExchange = (props) => {

    const handleInputChange = (value, id) => {
        const newData = {...props.data};
        newData[id].value = value;
        props.setData(newData);
    }

    return (
        <React.Fragment>        
            <FormGroup>  
                <GreyLabel>Exchange Rate</GreyLabel> 
                <Row>
                    <Col>
                        <InputGroup>
                            <HighlightedInput placeholder="1" 
                                            invalid={props.base.invalid} 
                                            type={props.type}
                                            value={props.base.value}
                                            onChange={e => handleInputChange(e.target.value, props.baseid)}/>
                            <HighlightedInputGroupText>
                            {props.destCurrency.value}
                            </HighlightedInputGroupText>
                        </InputGroup>
                    </Col>
                    <Col>
                        <InputGroup>
                            <HighlightedInput placeholder="" 
                                            invalid={props.convert.invalid} 
                                            type={props.type} 
                                            value={props.convert.value}  
                                            onChange={e => handleInputChange(e.target.value, props.convertid)} />
                            <HighlightedInputGroupText>
                            {props.clientCurrency.value}  
                            </HighlightedInputGroupText>
                        </InputGroup>
                    </Col>
                </Row>
                <SmallFormFeedback>Required</SmallFormFeedback>
            </FormGroup>
        </React.Fragment>
    )
} 

export default FormInputExchange;

export const HighlightedInput = styled(Input)`
    font-size: ${props => props.fontSize ? props.fontSize : "16px"};
    margin: ${props => props.fontSize === "16px" ? "" : "0px 0px"};
    border: none;
    border-bottom: 1px solid ${Colors.primaryLight};
    border-radius: 0px;
    background-color: ${Colors.primaryLight};
    color: ${Colors.primaryDark};
    padding: ${props => props.fontSize === "16px" ? "5px 5px" : ""};
    &:hover {
        border-bottom: 1px solid ${Colors.primaryAccent};
    }
`